import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { hasAny } from '../auth/permissions';
import NotFoundPage from './layout/NotFoundPage.jsx';

export default function ProtectedRoute({ children, required }) {
  const { permissions, isSuperuser, loading, authVersion } = useAuth(); // 🔑 fuerza re-evaluación
  const token = (typeof window !== 'undefined') ? localStorage.getItem('access_token') : null;

  if (!token) return <Navigate to="/login" replace />;
  if (loading) return null;

  if (isSuperuser) return children;

  if (!permissions || permissions.length === 0) {
    // Usuario autenticado pero sin permisos: mostrar 404 amigable
    return <NotFoundPage />;
  }
  if (required && !hasAny(permissions, required)) {
    // Ruta existente pero no autorizada para este usuario: tratar como 404
    return <NotFoundPage />;
  }
  // consumir authVersion para re-render sin usarlo
  void authVersion;
  return children;
}
